<template>
    <ModalWrapper v-model="dialog" :fullscreen="isMobile" max-width="1800">
        <template v-slot:activator="{props}">
            <v-btn
                variant="text"
                position="absolute"
                location="top right"
                size="x-small"
                icon="mdi-pencil"
                v-bind="props"
                @click="dialog = true"
            />
        </template>
        <template v-slot:title>
            {{ $t('modify.current_traveler_details') }}
        </template>
        <template v-slot:content>
            <v-form>
                <v-row v-for="tourist in persons" :key="tourist.travelerId" dense>
                    <v-col cols="12" md="1">
                        <v-select
                            v-model="tourist.prefix"
                            :items="['Mr', 'Ms', 'Mrs']"
                            :label="`${$t('salutation')}`"
                            :rules="[requiredRule('salutation')]"
                            required
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="tourist.firstName"
                            :label="`${$t('first_name')}`"
                            :rules="[requiredRule('first_name')]"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="tourist.lastName"
                            :label="`${$t('last_name')}`"
                            :rules="[requiredRule('last_name')]"
                        />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <date-picker
                            v-model="tourist.birthdate"
                            :label="$t('birthdate')"
                            :max="$dateFns.format(new Date())"
                            year-active-picker
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field v-model="tourist.number" :label="`${$t('document_number')}`" />
                    </v-col>
                    <v-col cols="12" md="2">
                        <date-picker
                            v-model="tourist.validTill"
                            :label="$t('expire_date')"
                            :rules="[requiredRule('expire_date')]"
                            :min="today"
                            year-active-picker
                        />
                    </v-col>
                </v-row>
            </v-form>
        </template>
        <template v-slot:btns>
            <v-btn :disabled="isLoading" color="primary" variant="flat" data-cy="save" @click="save">
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'

    @Component({components: {DatePicker}})
    export class EditTravelersDialog extends mixins(FormValidationRulesMixin) {
        @Prop({required: true}) travelers
        @Prop({required: true}) service

        isLoading = false
        persons = []
        dialog = false

        created() {
            this.persons = this.travelers.map(t => {
                return {
                    firstName: t.name[0].firstName || '',
                    middleName: t.name[0].middleName || '',
                    lastName: t.name[0].lastName || '',
                    prefix: t.prefix || '',
                    birthdate: t.dateOfBirth || '',
                    number: t.passports[0]?.number || '',
                    validTill: t.passports[0]?.expiryDate || '',
                }
            })
        }

        async save() {
            const processId = this.service.processId.replace(/^.{6}/, '')
            this.isLoading = true

            try {
                await this.$api.travellerData.put(processId, {
                    processId,
                    persons: this.persons,
                })
                await runtimeStore.refreshOrder()

                this.dialog = false
            } catch (e) {
                if (e.errors?.[0]?.errorType === 'validation' && e.errors?.[0]?.message) {
                    this.$toast.error(e.errors[0].message, {
                        timeout: 8000,
                    })
                } else {
                    this.$toast.error(this.$t('error_message.save_error'))
                }
            } finally {
                this.isLoading = false
            }
        }

        get today() {
            return this.$dateFns.format(new Date())
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default EditTravelersDialog
</script>
